import React, { FC, useEffect, useState } from "react";
import { Button, Table, Upload, message, Modal, Input } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { RouterParamType } from "@/model/navModel";
import { useDtpDetailModel } from "../dtpDetailModel";
import { EditableRow, EditableCell } from "@/components/YHEditTable/editTable";
import { formatInt, formatNum, formatNum4, getRandomStr } from "@/utils/utils";
import { IDtpMaterialDetail } from "../../../dtpTypes";
import { useGlobalModel } from "@/model/globalModel";
import { importPropsConfig1 } from "@/utils/importFile1";
import { useDictModel } from "@/views/base/dict/dictModel";
import { enquiryService } from "@/views/inquires/enquiry/enquiryService";

export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    const {
        addList,
        editList,
        addFormVal,
        editFormVal,
        updateList,
        removeMaterial,
        setMaterialDialog,
        exportDtp,
        downloadTpl,
        getDtpDetailOne
    } = useDtpDetailModel(({ addList, editList }) => [addList, editList]);
    const { user: { shopCode }, setLoadingInfo } = useGlobalModel(({ user }) => [user])

    const tableList = mode === "edit" ? editList : addList;
    const formVal = mode === "edit" ? editFormVal : addFormVal;

    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const { getTreeNodeNameValue } = useDictModel(() => []);
    useEffect(() => {
        if (!editFormVal.id && mode === "edit") {
            //debugger
            getDtpDetailOne(id)
        }
    }, [mode]);
    const column = [
        {
            title: '序号',
            width: 60,
            align: "center",
            fixed: "left",
            dataIndex: "totalTxt",
            render: (t: any, r: any, i: number) => <>{t ? t : i + 1}</>
           
        }, {
            title: '海关编码',
            width: 100,
            dataIndex: 'customsCode',
        }, {
            title: '商品名称',
            width: 160,
            dataIndex: 'materialName',
        },
        // {
        //     title: '规格型号',
        //     width: 160,
        //     dataIndex: 'model',
        // }, 
        {
            title: '规格型号',
            width: 160,
            dataIndex: 'customsEntry',
            //editable: true,
            editable:editFormVal.status!=='clearance-status.effect' ? true:false,
        },
        {
            title: '单位',
            width: 160,
            dataIndex: 'unitName',
        }, {
            title: '商品编码',
            width: 160,
            dataIndex: 'materialCode',
        }, {
            title: '数量',
            width: 160,
            dataIndex: 'num',
            editable:editFormVal.status!=='clearance-status.effect' ? true:false,
            // editable: true
        }, {
            title: '单价',
            width: 160,
            dataIndex: 'price',
            editable:editFormVal.status!=='clearance-status.effect' ? true:false,
            // editable: true,
            render: (text: any, record: any) => `${getTreeNodeNameValue(record.currency)}${formatNum4(text)}`,
        }, {
            title: '总价',
            width: 160,
            dataIndex: 'amount',
            editable:editFormVal.status!=='clearance-status.effect' ? true:false,
            // editable: true,
            render: (text: any, record: any) => `${getTreeNodeNameValue(record.currency)}${formatNum(text)}`,
        }, {
            title: '币制',
            width: 160,
            dataIndex: 'currency',
        }, {
            title: '原产国(地区)',
            width: 160,
            dataIndex: 'originCountry',
            editable:editFormVal.status!=='clearance-status.effect' ? true:false,
            // editable: true
        }, {
            title: '最终目的国(地区)',
            width: 160,
            dataIndex: 'destinationCountry',
            editable:editFormVal.status!=='clearance-status.effect' ? true:false,
            // editable: true
        }, {
            title: '境内货源地',
            width: 160,
            dataIndex: 'sourceSupply',
            editable:editFormVal.status!=='clearance-status.effect' ? true:false, 
            // editable: true
        }, {
            title: '征免',
            width: 160,
            dataIndex: 'shallBe',
            editable:editFormVal.status!=='clearance-status.effect' ? true:false,
            // editable: true
        },
    ];

    const newColumn = column.map((col: any, index) => {
        return {
            ...col,
            onCell: (record: any, rowIndex: number) => ({
                colIndex: index + 1,
                rowIndex,
                record,
                rules: col.rules,
                options: col.options,
                editType: col.editType,
                //最后一行合计不可以编辑
                editable: record.key === "totalAmount" ? false : col?.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave: handleSave,
            }),
        }
    })

    //内联编辑
    const handleSave = (row: any) => {
        let dataSource = [...tableList];
        const index = dataSource.findIndex((item) => row.key === item.key);
        const item = dataSource[index];

        row.num = +formatInt(row.num);
        row.price = +formatNum4(row.price);

        //修改总价， 不走计算
        if (+row.amount === +(item.amount ?? 0)) {
            row.amount = +formatNum(row.price * row.num);
        } else {
            row.amount = formatNum(row.amount);
        }

        dataSource.splice(index, 1, { ...item, ...row });
        updateList(mode, dataSource);
    }

    //导入明细成功
    const upLoadCallback = (list: IDtpMaterialDetail[]) => {
        setLoadingInfo({ loadingVisible: false, txt: "" });
        if (list && list.length) {
            let dataSource = [...tableList];
            let strArr: string[] = []
            list.forEach(material => {
                //选中的是否存在列表
                let isExist = dataSource.find(item => item.materialCode === material.materialCode);
                if (!isExist) {
                    let { id, ...item } = material;
                    dataSource.push({
                        ...item,
                        "key": getRandomStr(),  //自己用
                        "materialId": id, // "物料id",
                        "note": "", // "备注"
                    })
                } else {
                    strArr.push(material.materialName ?? "")
                }
            });
            strArr.length && message.warning(`【${strArr.join()}】重复的配件已做过滤`)
            updateList(mode, dataSource);
        }
    };

    const action = <>
        {/* <YhAuth resCode={ResourceAuthEnum.P_ED_ADD_M}> */}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => setMaterialDialog(true)}
        >新增</Button>
        {/* </YhAuth> */}
        {/* <YhAuth resCode={ResourceAuthEnum.P_ED_DEL_M}> */}

        {/* </YhAuth> */}
        {/* <YhAuth resCode={ResourceAuthEnum.P_ED_DLOAD}> */}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { downloadTpl() }}
        >下载模板</Button>
        {/* </YhAuth> */}
        {/* <YhAuth resCode={ResourceAuthEnum.P_ED_IM}> */}
        <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig1(`/gtm/inquiry/detail/import/${shopCode}`, upLoadCallback)}>
            <Button className="mr-5" type="link" shape="round">导入</Button>
        </Upload>
        {/* </YhAuth> */}
        {/* <YhAuth resCode={ResourceAuthEnum.P_ED_EX}> */}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { exportDtp() }}
        >导出</Button>
        {/* </YhAuth> */}
    </>

    const leftChildren = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            hidden={mode !== 'edit'}
            onClick={() => {
                if (selectedRowKeys.length !== 1) {
                    message.warning("请选择单条数据进行排序");
                    return;
                }
                let number = "";
                Modal.confirm({
                    title: "请输入排序数字",
                    content: <>
                        <Input placeholder="请输入排序数字" onChange={(e) => { number = e.target.value }} />
                    </>,
                    okText: '确定',
                    cancelText: '取消',
                    onOk: () => {
                        return new Promise((resolve, reject) => {
                            if (number && /^[+-]?\d*\.?\d*$/.test(number)) {
                                resolve(number);
                            } else {
                                message.warning("请输入排序数字");
                                reject('请输入排序数字');
                            }
                        }).then(async (res: any) => {
                            let { retData } = await enquiryService.customsOrderNum({
                                id: selectedRowKeys[0],
                                orderNum: +res
                            })
                            message.success("修改成功")
                        });
                    },
                    onCancel: () => { }
                })
            }}
        >修改顺位</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => {
                if (!selectedRowKeys.length) {
                    message.warning("请选择你要删除的商品");
                    return;
                }
                removeMaterial(mode, selectedRowKeys)
            }}
        >删除</Button>
    </>

    const totalRow = {
        key: "totalAmount",
        totalTxt: "合计:",
        price: formatNum4(tableList.reduce((con, next) => { con += +(next.price ?? 0); return con }, 0)),
        amount: formatNum(tableList.reduce((con, next) => { con += +(next.amount ?? 0); return con }, 0)),
    }
    return (
        // <YhBox title="商品信息" style={{ marginBottom: "10px" }} rightChildren={action}>
        <YhBox title={leftChildren} style={{ marginBottom: "10px" }} >
            <Table
                rowClassName='editable-row yh-edit-table-tr'
                rowSelection={{
                    selectedRowKeys: selectedRowKeys, //记录选中
                    onChange: (selectedRowKeys: React.Key[], selectedRows: IDtpMaterialDetail[]) => {
                        setSelectedRowKeys(selectedRowKeys as string[]);
                    }
                }}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                columns={newColumn as ColumnsType<any>}
                dataSource={tableList.length > 0 ? [...tableList, totalRow] : []}
                pagination={false}
                scroll={{ x: 'max-content', y: 400 }}
            />
        </YhBox>
    )
}

